import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { collectAddress, deleteAddress, createAddress } from "redux/admin/cryptoaddress/cryptoAddressSlice";
import { MdOutlineDone, MdClear } from "react-icons/md";
import swal from 'sweetalert';

const CryptoAddresses = ({ data }) => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [paymentKey, setPaymentKey] = useState("");
  const [namesurname, setNameSurname] = useState("");

  const handleCollect = (id, balance) => {
    swal({
      title: "USDT çekim",
      text: `USDT çekim miktarı (tümü için boş bırakın):`,
      content: "input",
      buttons: {
        cancel: "İptal",
        confirm: {
          text: "Devam"
        }
      }
    })
    .then((value) => {
      if (value === null) {
        // User clicked cancel
        return;
      }
      
      let amount = null;
      
      if (value && value.trim() !== "") {
        // Custom amount entered
        const inputAmount = parseFloat(value.trim());
        if (isNaN(inputAmount) || inputAmount <= 0) {
          swal("Hata", "Geçerli bir miktar girin!", "error");
          return;
        }
        
        const maxAmount = balance;
        if (inputAmount > maxAmount) {
          swal("Hata", `Maksimum çekilebilir miktar: ${maxAmount.toFixed(6)} USDT`, "error");
          return;
        }
        
        // Convert to backend format (multiply by 1,000,000)
        amount = Math.floor(inputAmount * 1000000);
      }
      // If value is empty or null, amount stays null (collect all)
      
      // Now ask for destination address
      swal({
        title: "Hedef Adres",
        text: "Hedef cüzdan adresi (varsayılan adres için boş bırakın):",
        content: "input",
        buttons: {
          cancel: "İptal",
          confirm: {
            text: "Çek"
          }
        }
      })
      .then((destAddress) => {
        if (destAddress === null) {
          // User clicked cancel
          return;
        }
        
        // destAddress can be empty string (use default) or a valid address
        const dest_address = destAddress && destAddress.trim() !== "" ? destAddress.trim() : null;
        
        dispatch(collectAddress({ id, amount, dest_address }));
      });
    });
  };

  const handleCollectTrx = (id) => {
    swal({
      title: "TRX çekim",
      text: `TRX çekim miktarı (tümü için boş bırakın):`,
      content: "input",
      buttons: {
        cancel: "İptal",
        confirm: {
          text: "Devam"
        }
      }
    })
    .then((value) => {
      if (value === null) {
        // User clicked cancel
        return;
      }

      let amount = null;

      if (value && value.trim() !== "") {
        // Custom amount entered (in TRX)
        const inputAmount = parseFloat(value.trim());
        if (isNaN(inputAmount) || inputAmount <= 0) {
          swal("Hata", "Geçerli bir miktar girin!", "error");
          return;
        }

        // Convert TRX to SUN (multiply by 1,000,000)
        amount = Math.floor(inputAmount * 1000000);
      }
      // If value is empty or null, amount stays null (collect all minus fee reserve)

      // Now ask for destination address
      swal({
        title: "Hedef Adres",
        text: "Hedef cüzdan adresi (varsayılan adres için boş bırakın):",
        content: "input",
        buttons: {
          cancel: "İptal",
          confirm: {
            text: "Çek"
          }
        }
      })
      .then((destAddress) => {
        if (destAddress === null) {
          // User clicked cancel
          return;
        }

        const dest_address = destAddress && destAddress.trim() !== "" ? destAddress.trim() : null;

        dispatch(collectAddress({ id, amount, dest_address, currency: "trx" }));
      });
    });
  };

  const handleDelete = (id) => {
    dispatch(deleteAddress(id));
  };

  const toggleForm = () => {
    setShowForm(!showForm);
  };

  const handleCreateAddress = (e) => {
    e.preventDefault();
    // Dispatch createAddress action
    dispatch(createAddress({ payment_key: paymentKey, namesurname }));
    // Optionally clear form fields & hide form
    setPaymentKey("");
    setNameSurname("");
    setShowForm(false);
  };

  return (
    <div className="overflow-x-auto p-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-semibold text-white-100">Crypto Addresses</h3>
        <button
          onClick={toggleForm}
          className="bg-primary text-white px-4 py-2 rounded-md font-semibold"
        >
          Yeni Adres Oluştur
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleCreateAddress} className="bg-gray-800 p-4 mb-4 rounded-md">
          <div className="mb-2">
            <label className="block text-white-100 font-medium mb-1" htmlFor="payment_key">
              Payment Key
            </label>
            <input
              id="payment_key"
              type="text"
              value={paymentKey}
              onChange={(e) => setPaymentKey(e.target.value)}
              className="w-full p-2 rounded-md"
              required
            />
          </div>
          <div className="mb-2">
            <label className="block text-white-100 font-medium mb-1" htmlFor="namesurname">
              Ad Soyad
            </label>
            <input
              id="namesurname"
              type="text"
              value={namesurname}
              onChange={(e) => setNameSurname(e.target.value)}
              className="w-full p-2 rounded-md"
              required
            />
          </div>
          <button
            type="submit"
            className="bg-green-600 text-white px-4 py-2 mt-2 rounded-md font-semibold"
          >
            Submit
          </button>
        </form>
      )}

      <table className="min-w-full divide-y-2 divide-gray-200 text-sm">
        <thead>
          <tr>
            <th className="px-4 py-2 text-left text-white-100">ID</th>
            <th className="px-4 py-2 text-left text-white-100">Payment Key</th>
            <th className="px-4 py-2 text-left text-white-100">Ad Soyad</th>
            <th className="px-4 py-2 text-left text-white-100">Adres</th>
            <th className="px-4 py-2 text-left text-white-100">Coin Türü</th>
            <th className="px-4 py-2 text-left text-white-100">Bakiye</th>
            <th className="px-4 py-2 text-left text-white-100">İşlemler</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {data?.map((addr) => (
            <tr key={addr.id}>
              <td className="px-4 py-2 text-white-100">{addr.id}</td>
              <td className="px-4 py-2 text-white-100">{addr.payment_key}</td>
              <td className="px-4 py-2 text-white-100">{addr.namesurname}</td>
              <td className="px-4 py-2 text-white-100">{addr.address}</td>
              <td className="px-4 py-2 text-white-100">{addr.currency}</td>
              <td className="px-4 py-2 text-white-100">{addr.balance}</td>
              <td className="px-4 py-2 text-white-100">
                <div className="flex gap-2">
                  {/* Collect button */}
                  <button
                    onClick={() => handleCollect(addr.id, addr.balance)}
                    className="bg-primary text-white rounded-md px-2 py-1 flex items-center font-semibold"
                  >
                    <MdOutlineDone className="mr-1" /> USDT Aktar
                  </button>
                  {/* Collect TRX button */}
                  <button
                    onClick={() => handleCollectTrx(addr.id)}
                    className="bg-yellow-600 text-white rounded-md px-2 py-1 flex items-center font-semibold"
                  >
                    <MdOutlineDone className="mr-1" /> TRX Aktar
                  </button>
                  {/* Delete button */}
                  <button
                    onClick={() => handleDelete(addr.id)}
                    className="bg-red-500 text-white rounded-md px-2 py-1 flex items-center font-semibold"
                  >
                    <MdClear className="mr-1" /> Sil
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CryptoAddresses;
